const ProductSliderShimmer = () => {
  return (
    <div className="container mx-auto md:mt-5 md:mb-5 mt-4 overflow-hidden">
      {/* Header */}
      <div className="flex justify-between items-center px-4 pb-4">
        <div className="h-7 w-48 rounded bg-gray-200 animate-pulse" />
        <div className="h-5 w-20 rounded bg-gray-200 animate-pulse" />
      </div>

      {/* Cards */}
      <div className="flex gap-5 px-4 overflow-hidden">
        {[...Array(5)].map((_, index) => (
          <div
            key={index}
            className="flex-shrink-0 md:w-[240px] w-[47%] bg-white rounded-[10px] overflow-hidden"
          >
            {/* Image shimmer */}
            <div className="aspect-[315/460] w-full bg-gray-200 animate-pulse" />

            {/* Content */}
            <div className="p-3">
              <div className="h-4 w-3/4 rounded bg-gray-200 animate-pulse mb-2" />
              <div className="h-3 w-1/2 rounded bg-gray-200 animate-pulse mb-3" />

              {/* Price */}
              <div className="flex gap-2 mb-4">
                <div className="h-4 w-12 rounded bg-gray-200 animate-pulse" />
                <div className="h-4 w-16 rounded bg-gray-200 animate-pulse" />
              </div>

              {/* Buttons */}
              <div className="flex gap-2">
                <div className="h-9 flex-1 rounded bg-gray-200 animate-pulse" />
                <div className="h-9 w-10 rounded bg-gray-200 animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSliderShimmer;
